// extracted by css-extract-rspack-plugin
export default {"tabs":"CbRoYfC2dYUHz6ys","list":"qiQEZyrvUnIWlGIi","tab":"ptm22bC9uxgPJ7xp yjEOWr1wvMI7B708","panel":"A570Pg3R_2Mb4oNx"};